var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-footer"},[_c('span',{staticClass:"copyright"},[_c('a',{staticClass:"text",attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("粤ICP备2022082317号")]),_c('p',{staticClass:"copyright-text"},[_vm._v("Copyright © vipcheck "+_vm._s(_vm.year)+" all right reserved.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }